<template>
  <div id="box" class="list-page">
    <Header></Header>
    <Menulist></Menulist>

    <!-- 支付测试面板 v-if=""-->
    <div v-if="payTestShow()" class="paydemo" style="width: 100%">
      <div class="paydemo-type-content">
        <div v-show="showTitle('WX')" class="paydemo-type-name article-title">
          微信支付
        </div>
        <div class="paydemo-type-body">
          <div
              v-show="appPaywayList.indexOf('WX_NATIVE') >= 0"
              :class="{ this: currentWayCode === 'WX_NATIVE' }"
              class="paydemo-type color-change"
              @click="changeCurrentWayCode('WX_NATIVE', 'codeImgUrl')"
          >
            <img
                class="paydemo-type-img"
                src="@/assets/payTestImg/wx_native.svg"
            /><span class="color-change">微信二维码</span>
          </div>

          <div
              v-show="appPaywayList.indexOf('WX_BAR') >= 0"
              :class="{ this: currentWayCode === 'WX_BAR' }"
              class="paydemo-type color-change"
              @click="changeCurrentWayCode('WX_BAR', '')"
          >
            <img
                class="paydemo-type-img"
                src="@/assets/payTestImg/wx_bar.svg"
            /><span class="color-change">微信条码</span>
          </div>

          <div
              v-show="appPaywayList.indexOf('WX_JSAPI') >= 0"
              :class="{ this: currentWayCode === 'WX_JSAPI' }"
              class="paydemo-type color-change"
              @click="changeCurrentWayCode('WX_JSAPI', 'codeImgUrl')"
          >
            <img
                class="paydemo-type-img"
                src="@/assets/payTestImg/wx_jsapi.svg"
            /><span class="color-change">公众号/小程序</span>
          </div>

          <div
              v-show="appPaywayList.indexOf('WX_H5') >= 0"
              :class="{ this: currentWayCode === 'WX_H5' }"
              class="paydemo-type-h5"
              @click="changeCurrentWayCode('WX_H5', 'payurl')"
          >
            <img
                class="paydemo-type-img"
                src="@/assets/payTestImg/wx_h5.svg"
            /><span class="color-change">微信H5</span>
          </div>
        </div>
      </div>
    </div>

    <div class="page-main">
      <!-- 配置提示 -->
      <div class="page-alert" v-if="!appId">请选择应用APPID</div>
      <div class="page-alert" v-else-if="noConfigText">您尚未配置任何支付方式</div>

      <el-card class="list-card">
        <div slot="header" class="card-head">
          <span class="card-head__title">我的网卡</span>
          <span class="card-head__right">
            <span class="card-head__count">共 {{ total }} 条</span>
            <el-button v-if="vallist.length != 0" size="small" type="primary" @click="handlePay">确认支付</el-button>
          </span>
        </div>

      <el-table
          :key="'tableKey'"
          :data="datas"
          border
          fit
          highlight-current-row
          style="width: 100%"
          stripe

      >

        <el-table-column label="使用单位" align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" :content="row.ybdept" placement="top-start">
              <span>{{ row.ybdept }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column label="信用代码" width="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.yscode }}</span>
          </template>
        </el-table-column>

        <el-table-column label="ICCID(卡号)"  align="center">
          <template slot-scope="{ row }">
            <span>{{ row.iccid }}</span>
          </template>
        </el-table-column>

        <el-table-column label="医保SN"  align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ybsn }}</span>
          </template>
        </el-table-column>

        <el-table-column label="设备SN"  align="center">
          <template slot-scope="{ row }">
            <span>{{ row.sn }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="联系人" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.uname }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="联系电话" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.uphone }}</span>
          </template>
        </el-table-column>


        <el-table-column align="center" label="服务到期时间" width="130">
          <template slot-scope="{ row }">
            <span>{{ row.endtime }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="到期天数" width="80">
          <template slot-scope="{ row }">
            <span style="color: red;font-weight: bold">{{ getDaysDifference(row.endtime) == 0 ? '已过期':getDaysDifference(row.endtime) }}</span>
          </template>
        </el-table-column>

        <!--  这块需要管理员权限     -->
        <el-table-column align="center" class-name="small-padding" label="操作" width="100" >
          <template slot-scope="{ row, $index }">
            <el-button plain size="mini" type="warning" @click="chakanLook(row,2)">
              查看
            </el-button>
            <!--            <el-button plain size="mini" type="success" @click="onexamine(row)">-->
            <!--              前往支付-->
            <!--            </el-button>-->
          </template>
        </el-table-column>
      </el-table>

        <div class="list-card__pager">
          <pagination v-if="total > 0" :limit.sync="listQuery.pagesize" :page.sync="listQuery.page" :total="total" @pagination="getlist"/>
        </div>
      </el-card>
    </div>



    <el-dialog title="详情" :visible.sync="dialogVisibleDetails" width="45%" custom-class="detail-dialog">
      <el-divider content-position="center">使用单位信息</el-divider>
      <el-card class="box-card">
        <!-- 单位名称通常很长，单独占整行，避免在窄列里折行 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="box_list">
              <div class="box_list_title">单位名称：</div>
              <div class="box_list_content">{{orderinfo.ybdept}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">信用代码：</div>
              <div class="box_list_content">{{orderinfo.yscode}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">联系人：</div>
              <div class="box_list_content">{{orderinfo.uname}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">联系方式：</div>
              <div class="box_list_content">{{orderinfo.uphone}}</div>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-divider content-position="center">网卡信息</el-divider>
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">资费方式：</div>
              <div class="box_list_content">包年</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">运营商：</div>
              <div class="box_list_content">{{ orderinfo.yys }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">终端设备SN：</div>
              <div class="box_list_content">{{orderinfo.sn}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">终端医保SN：</div>
              <div class="box_list_content">{{orderinfo.ybsn}}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">ICCID(卡号)：</div>
              <div class="box_list_content">{{orderinfo.iccid}}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="box_list">
              <div class="box_list_title">到期时间：</div>
              <div class="box_list_content">{{orderinfo.endtime}}</div>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <span slot="footer" class="dialog-footer detail-footer">
        <el-button @click="dialogVisibleDetails = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleDetails = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 二维码弹窗 -->
    <pay-test-modal
        ref="payTestModal"
        @closeBarCode="$refs.payTestBarCode.visible = false"
    ></pay-test-modal>

    <!-- 条码弹框 -->
    <pay-test-bar-code
        ref="payTestBarCode"
        @CodeAgainChange="testCodeChange"
        @barCodeValue="barCodeChange"
    ></pay-test-bar-code>


    <el-dialog title="确认支付" :visible.sync="dialogVisible" width="75%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="购买套餐" prop="priceid">
          <el-radio-group v-model="ruleForm.priceid" >
            <el-radio v-for="item in priceList" :label="item.id" :key="item.id" border>{{ item.description }} <i>{{item.price}}元</i></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="选择年限" prop="totalnum">
              <el-input-number v-model="ruleForm.totalnum"  :min="1" :max="20" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付方式" prop="paymethod">
              <el-radio-group v-model="ruleForm.paymethod" size="mini">
                <el-radio :label="1" border>线上支付</el-radio>
<!--                <el-radio :label="2" border>线下支付</el-radio>-->
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input type="email" v-model="ruleForm.email" placeholder="请输入邮箱" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票规则" >
              <div>发票将在支付成功后3-5个工作日发送邮箱（注：不要填写企业内部邮件地址）</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单位名称" prop="company">
              <el-input v-model="ruleForm.company" placeholder="请输入联系人" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="信用代码" prop="yscode">
              <el-input v-model="ruleForm.yscode" placeholder="请输入联系电话" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>



        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入联系人" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入联系电话" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>





        <el-form-item style="display: flex;justify-content: flex-end;align-items: center;">
          <el-button type="primary" @click="submitForm('ruleForm')">立即支付</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>




      <!--      <span slot="footer" class="dialog-footer">-->
      <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
      <!--        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
      <!--      </span>-->
    </el-dialog>






    <Footer></Footer>
  </div>
</template>

<script>
import {
  getInfo,
  mail_send,
  mallOrderdata_apply_refund,
  mallOrderdata_deal_seal_list,
  mallOrderdata_getrestnum,
  order_orderlist,
  order_paywaitpay,
  card_selectlist,
  cardPrice_priceList,
  order_paycard
} from '@/api/manage' // 接口
import {Carousel} from 'ant-design-vue'
import PayTestModal from "./PayModal"; // 二维码对话框组件
import Pagination from '@/components/Pagination'
import Header from "@/components/heard/index.vue";
import Footer from "@/components/footer/index.vue";
import {getToken, removeToken} from "@/utils/auth";
import img from "@/assets/shili.png";
import jianceimg from "@/assets/key_images.png";
import PayTestBarCode from "@/views/seal/PayBarCode.vue";
import Menulist from "@/components/menulist/index.vue";


export default {
  name: 'paytest',
  props: {},
  components: {Menulist, PayTestModal, PayTestBarCode, Carousel, Pagination, Header, Footer},
  data() {
    return {
      listQuery:{
        userid:'',
        status:2,
        pagesize:10,
        page:1,
        yscode:'',
        orgcode:'',
      },
      total:0,
      priceList: [],
      ruleForm: {
        priceid:'',
        totalnum:1,
        paymethod:1,
        company:'',
        yscode:'',
        name:'',
        phone:'',
        email:'',
        iccids:'',
        isdaiban:2,
        paymenthod:"ALI_QR",
        optype:"pc",

      },
      rules: {
        priceid: [
          { required: true, message: '请选择套餐', trigger: 'change' },
        ],
        totalnum: [
          { required: true, message: '请选择购买年限', trigger: 'change' },
        ],
        paymethod: [
          { required: true, message: '请选择支付方式', trigger: 'change' },
        ],
        company: [
          { required: true, message: '请输入单位名称', trigger: 'blur' },
        ],
        yscode: [
          { required: true, message: '请输入信用代码', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
        ],
      },
      companyinfostatus:true,
      jianceimg:jianceimg,
      current: ["ukey"],
      sssvisiblesss: true,
      visiblemodd: false,
      // urlop:'images/93750.png',
      totalnum: 1,
      checked1: false,
      form: this.$form.createForm(this, {name: "coordinated"}),
      dialogStyle: {
        top: "40%",
      },
      dialogVisiblesss: false,
      phone: '',
      expressno:'',
      phonelist:[],
      Downloadstatus:false,
      headers: { Authorization: "Bearer " + localStorage.getItem("setToken") ,appid:CONFIG.appid},
      updatedata: {  uploadtype: "document",id:''},
      actionurl:'',
      chongxinactionurl:'',
      orderinfo:'',
      fileList: [],
      fileLists: [],
      dialogVisibleDetails:false,
      nowcompany: '',
      nowemail: '',
      listLoading: false,
      textarea: '',
      yscode: '',
      dialogVisible:false,
      sdisableds: false,
      timer: 60,
      mailbox: '',
      mailboxcode: '',
      datas: [],
      loading: false,
      pattern: '/^\\w+((-\\w+)|(\\.\\w+))*@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$/',
      imgurl: require('@/assets/images/key.png'),
      imgbg: require('@/assets/images/topbg.jpeg'),
      mchAppList: [], // app列表
      appId: '2021003131636388', // 已选择的appId
      appPaywayList: ['ALI_QR'], // 商户app支持的支付方式
      currentWayCode: 'ALI_QR', // 以何种方式进行支付，默认是微信二维码
      currentPayDataType: '', // 支付参数
      mchOrderNo: '', // 模拟商户订单号
      authCode: '', // 条码的值
      companyyscode: '',
      paytestAmount: '0.01', // 支付金额，默认为0.01
      amountInput: false, // 自定金额输入框是否展示
      noConfigText: false, // 尚无任何配置分割线提示文字
      divisionMode: 0, // 订单分账模式
      orderTitle: '接口调试', // 订单标题
      value: 1,
      checked: false,
      checkeddef: true,
      sendmethod: 1,
      valuests: null,
      outtime: null,
      disabledlook: false,
      activities:[],
      visibletongzhi: false,
      visiblelook: false,
      valueaw: 2,
      valiBtn: '同意条款',
      ModalText: '阅读协议，哈哈首科大厦大家安康',
      visible: false,
      companyname: '',
      confirmLoading: false,
      radioStyle: {
        cursor: 'pointer',
        marginleft: '10px',
        height: '30px',
        lineHeight: '30px',
        color: '#132b75',
      },
      page: 1,
      pagesize: 10,
      mpd: null,
      vshow: true,
      isshowFooter: false,
      tobonumber: null,
      tobonum: null,
      Byyouji: null,
      number: {
        value: 11,
      },
      ID:'',
      year: null,
      month: null,
      dates: null,
      btnTime: null,
      projectname: '',
      xmalimg: '',
      usbkeyimg: '',
      maile: '',
      companytitle: '',
      notice: '',
      imgurlas: '',
      refunddata: {},
      configdata: {},
      orderid:'',
      OrderType:'',
      vallist:[],
    }
  },
  created() {
    this.actionurl = '/prod/mallOrderdata/upload_seal'
    this.chongxinactionurl = '/prod/mallOrderdata/upload_seal_retry'
    // cardPrice_priceList,type:1网卡，type:2组合套餐，type:3终端
    cardPrice_priceList({page:1,pagesize:10,type:1}).then(response => {
      this.priceList = response.data.data
    })
    getInfo({}).then(response => {
      // console.log(response)
      this.yscode = response.user.userName
      this.userid = response.user.userId
      this.orgcode = response.user.orgcode
      this.ruleForm.company = response.user.userName
      this.ruleForm.yscode = response.user.userName
      this.ruleForm.name = response.user.nickName
      this.ruleForm.phone = response.user.phonenumber
      this.ruleForm.email = response.user.email
      this.nowcompany = response.user.userName
      this.getlist()
    })
  },
  methods: {
    getDaysDifference(dateStr) {
      const now = new Date(); // 当前时间
      const eventDate = new Date(dateStr); // 事件时间
      if(now > eventDate){
        const diffDays = 0
        return diffDays;
      }else{
        const diffTime = Math.abs(now - eventDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 转换为天数
        return diffDays+'天';
      }

    },
    selectionChangeHandlerOrder(val) {
      this.vallist = []
      if (val.length !== 0) {
        // console.log(val)
        for (let i = 0; i < val.length; i++) {
          this.vallist.push(val[i].iccid)
        }
      }else{
        this.vallist = []
      }
    },
    handlePay(){
      console.log(this.vallist)
      var iccids = this.vallist.join(',')
      this.ruleForm.iccids = iccids
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this
          if (
              !this.$refs.payTestBarCode.getVisible() &&
              (this.currentWayCode === "WX_BAR" ||
                  this.currentWayCode === "ALI_BAR" ||
                  this.currentWayCode === "AUTO_BAR")
          ) {
            this.$refs.payTestBarCode.showModal();
            return;
          }
          // order_paycard
          order_paycard(that.ruleForm).then(response => {
            // console.log(response)
            that.$refs.payTestModal.showModal(this.currentWayCode, response.data); // 打开弹窗
            that.randomOrderNo(); // 刷新订单号
            that.getlist()
            that.dialogVisible = false
            this.kong()
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.dialogVisible = false
      this.$refs[formName].resetFields();
    },
    kong(){
      this.ruleForm = {
        priceid:'',
        totalnum:1,
        paymethod:1,
        company:'',
        yscode:'',
        name:'',
        phone:'',
        iccids:''
      }
    },

    getlist() {
      this.listLoading = true
      this.listQuery.orgcode =  this.orgcode
      this.listQuery.userid =  this.userid
      card_selectlist(this.listQuery).then(response => {
        // console.log(response.data.total,'response.data.total')
        this.datas = response.data.data
        this.total = response.data.total
      })
    },
    handleClose(tab, event) {
      console.log(tab, event);
    },
    // 条码弹窗点击x或者蒙版关闭
    testCodeChange() {
      this.randomOrderNo(); // 刷新订单号
    },
    barCodeChange(value) {
      this.authCode = value;
      this.immediatelyPay();
    },
    xaizaidealfileurl(row){
      window.open( '/prod/mallOrderdata/download_seal?filename='+row.dealfilename)
      // window.location.href = row
    },
    paywaitpay(row){
      var that = this
      if (
          !this.$refs.payTestBarCode.getVisible() &&
          (this.currentWayCode === "WX_BAR" ||
              this.currentWayCode === "ALI_BAR" ||
              this.currentWayCode === "AUTO_BAR")
      ) {
        this.$refs.payTestBarCode.showModal();
        return;
      }

      order_paywaitpay({orderid: row.id}).then(response => {
        // console.log(response,'+++++++')
        that.$refs.payTestModal.showModal(this.currentWayCode, response.data); // 打开弹窗
        that.randomOrderNo(); // 刷新订单号
        that.getlist()
        // this.phonelist = response.data.data
      })
    },
    // 刷新订单号
    randomOrderNo() {
      this.getlist()
      this.mchOrderNo =
          "M" +
          new Date().getTime() +
          Math.floor(Math.random() * (9999 - 1000) + 1000);
    },

    chakanLook(row,index){
      if(index == 1){
        if(row.ordertype == 4){
          this.orderid = row.id
          mallOrderdata_deal_seal_list({orderid: row.id}).then(response => {
            this.phonelist = response.data.data
          })
        }
      }
      this.orderinfo = row
      this.dialogVisibleDetails = true


    },
    userinfo(){
      this.$router.push('/userinfo');
    },
    homepay() {
      this.$router.push('/');
    },
    handleSubmits() {
      this.$router.push('/');
    },
    payTestShow() {
      // 如果未选择appid，或者支付方式列表为0，则不显示支付体验板块
      if (this.appId === "" || this.appPaywayList.length === 0) {
        return false;
      } else {
        return true;
      }
    },
    // 此处判断，微信，支付宝，聚合码，哪种支付方式一个都没配置，如果未配置，则不显示该板块，若等于-1 则表示不存在
    showTitle(parameterA) {
      if (this.appPaywayList.toString().indexOf(parameterA) === -1) {
        return false;
      } else {
        return true;
      }
    },
    showModal(e) {
      // mallOrderdata/getrestnum
      mallOrderdata_getrestnum({id: e}).then(response => {
        this.refunddata = response.data
        this.Id = e
        this.textarea = ''
        this.visible = true;
      })
    },
    handleCancel(e) {
      this.textarea = ''
      this.visible = false;
    },
  }
}
</script>

<style lang="css" scoped>
@import './payTest.css';

b {
  color: #333;
}

#box {
  display: block;
  width: 100%;
  overflow: hidden;
  background-image: url('../../assets/bg1.png');
  background-size: 100% 100%;
  background-position: center;
  background-attachment: fixed; /* 背景图片固定 */
  min-height: 100vh; /* 至少为视口高度 */
  padding-bottom:20px;
  box-sizing: border-box;
}


.biaoti {
  display: flex;
  flex-direction: row;
  font-size: 35px;
  font-weight: bold;
  text-align: center;
  font-family: "黑体";
}

.shangpinbiaoti {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
}

#searchbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;

}
.financeitem{padding: 5px;border-bottom: #ccc dashed 1px;}
#leftbar {
  display: flex;
  flex-direction: row;
}

.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: '';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}

/* ===== 列表页骨架（与首页统一；页面背景沿用 #box 上的 bg1.png） ===== */
.page-main {
  width: 100%;
  padding: 18px 30px 24px;
  box-sizing: border-box;
}

/* 配置提示条 */
.page-alert {
  margin-bottom: 14px;
  padding: 10px 16px;
  border-radius: 8px;
  background: #fef0f0;
  color: #e53935;
  font-size: 13px;
}

/* 列表卡片 */
.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-head__title {
  position: relative;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
}

.card-head__title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #f56c6c 0%, #e53935 100%);
}

.card-head__right {
  display: flex;
  align-items: center;
}

.card-head__count {
  margin-right: 14px;
  font-size: 12px;
  color: #86909c;
}

/* ===== 详情弹窗：字段行不再固定高度，长文本在自身列内换行 ===== */
.box_list{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-height: 38px;
  padding: 8px 0;
  box-sizing: border-box;
}

.box_list_title{
  flex: none;
  width: 92px;
  line-height: 22px;
  color: #86909C;
}

.box_list_content{
  flex: 1;
  min-width: 0;
  line-height: 22px;
  color: #1D2129;
  word-break: break-all;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

/* 弹窗头部 / 分节标题 / 卡片 / 底部按钮 */
::v-deep .detail-dialog {
  border-radius: 14px;
  overflow: hidden;
}

::v-deep .detail-dialog .el-dialog__header {
  padding: 18px 24px;
  border-bottom: 1px solid #F0F1F4;
}

::v-deep .detail-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: bold;
  color: #1D2129;
}

::v-deep .detail-dialog .el-dialog__headerbtn {
  top: 19px;
  right: 20px;
}

::v-deep .detail-dialog .el-dialog__body {
  padding: 6px 24px 4px;
  max-height: 62vh;
  overflow-y: auto;
}

::v-deep .detail-dialog .el-dialog__footer {
  padding: 0 24px 20px;
}

::v-deep .detail-dialog .el-divider--horizontal {
  margin: 14px 0 12px;
  background-color: #F0F1F4;
}

::v-deep .detail-dialog .el-divider__text {
  padding: 0 12px;
  font-size: 13px;
  font-weight: bold;
  color: #1D2129;
  background-color: #fff;
}

.box-card {
  border-color: #F0F1F4;
  border-radius: 10px;
  box-shadow: none;
}

.box-card ::v-deep .el-card__body {
  padding: 6px 20px;
}

.detail-footer .el-button {
  min-width: 88px;
  height: 36px;
  border-radius: 8px;
  font-size: 14px;
}

.detail-footer .el-button--default {
  border-color: #E6E8EB;
  color: #4E5969;
}

.detail-footer .el-button--default:hover,
.detail-footer .el-button--default:focus {
  border-color: #C9D3E0;
  background: #F7F8FA;
  color: #1D2129;
}

.detail-footer .el-button--primary {
  border: none;
  color: #fff;
  background: linear-gradient(90deg, #E5453F 0%, #F0605C 100%);
  box-shadow: 0 6px 14px rgba(229, 69, 63, 0.24);
}

.detail-footer .el-button--primary:hover,
.detail-footer .el-button--primary:focus {
  color: #fff;
  background: linear-gradient(90deg, #CC3A34 0%, #E04F4A 100%);
}

/* 分页收进卡片内，去掉分页组件自带的大留白 */
.list-card__pager ::v-deep .pagination-container {
  padding: 16px 0 0;
  background: transparent;
}

/* 分页靠最右侧：覆盖分页组件默认的居中（用 !important 压过组件内 scoped 规则） */
.list-card__pager ::v-deep .pagination-container .el-pagination {
  justify-content: flex-end !important;
}

@media screen and (max-width: 768px) {
  .page-main {
    padding: 16px 16px 24px;
  }
}

span{
  overflow:hidden; /*超出一行文字自动隐藏*/
  text-overflow:ellipsis;/*文字隐藏后添加省略号*/
  white-space:nowrap;  /*强制不换行*/
}
</style>
